import dayjs from 'dayjs';

import type { OptionEntityWithAdditionalFields } from '@/types/OptionEntity';

type LifespanItem = {
  label: string;
  durationMonths: number;
};

const LIFESPANS: LifespanItem[] = [
  { label: '3 месяца', durationMonths: 3 },
  { label: '6 месяцев', durationMonths: 6 },
  { label: '1 год', durationMonths: 12 },
  { label: '2 года', durationMonths: 24 },
];

export type LifespanOptionEntity = OptionEntityWithAdditionalFields<string, string, { durationMonths: number }>;

const PERMANENT_OPTION: LifespanOptionEntity = {
  key: '',
  value: 'Бессрочно',
  durationMonths: 0,
};

export const LIFESPAN_OPTIONS: LifespanOptionEntity[] = [
  ...LIFESPANS.map(({ label, durationMonths }) => ({
    key: dayjs().add(durationMonths, 'month').startOf('day').toISOString(),
    value: label,
    durationMonths,
  })),
  PERMANENT_OPTION,
];
